import React from 'react';
import { Button, Divider, Flex } from '@/components/ui';
import { IconFilePlus, IconFolderPlus, IconX } from '@tabler/icons-react';
import { UseUploadHandlersReturn } from '../types';

interface FileUploadActionsProps {
  handlers: Pick<
    UseUploadHandlersReturn,
    | 'folderInputRefActions'
    | 'filesInputRefActions'
    | 'handleAddFolder'
    | 'handleAddMoreFiles'
    | 'handleFolderChangeActions'
    | 'handleFilesChangeActions'
    | 'handleClearAllFiles'
  >;
  onAddMoreFiles?: () => void;
  getInputProps?: () => React.InputHTMLAttributes<HTMLInputElement>;
  disabled?: boolean;
}

export const FileUploadActions: React.FC<FileUploadActionsProps> = ({
  handlers,
  onAddMoreFiles,
  getInputProps,
  disabled = false,
}) => {
  void onAddMoreFiles;
  const {
    folderInputRefActions,
    filesInputRefActions,
    handleAddFolder,
    handleAddMoreFiles,
    handleFolderChangeActions,
    handleFilesChangeActions,
    handleClearAllFiles,
  } = handlers;

  return (
    <Flex align="center" gap="3" style={{ display: 'inline-flex' }}>
      <Button
        startIcon={<IconX />}
        variant="surface"
        color="error"
        size="small"
        type="button"
        onClick={handleClearAllFiles}
        disabled={disabled}
      >
        Clear All Files
      </Button>

      <Divider orientation="vertical" size="small" />

      <Button
        variant="outlined"
        size="small"
        type="button"
        onClick={handleAddFolder}
        startIcon={<IconFolderPlus />}
        disabled={disabled}
      >
        Add Folder
      </Button>

      <Button
        variant="outlined"
        size="small"
        type="button"
        onClick={handleAddMoreFiles}
        startIcon={<IconFilePlus />}
        disabled={disabled}
      >
        Add More Files
      </Button>

      {/* Hidden inputs */}
      {getInputProps && (
        <input {...getInputProps()} style={{ display: 'none' }} />
      )}

      <input
        ref={folderInputRefActions}
        type="file"
        style={{ display: 'none' }}
        multiple
        // @ts-expect-error webkitdirectory is non-standard but needed for folder upload
        webkitdirectory="true"
        onChange={handleFolderChangeActions}
      />

      <input
        ref={filesInputRefActions}
        type="file"
        style={{ display: 'none' }}
        multiple
        onChange={handleFilesChangeActions}
        className="file-upload-input"
      />
    </Flex>
  );
};
